























































import Fieldset from '~/components/car/classifieds/form/fieldsets/handlers/Fieldset.vue'
import BaseFieldsetMixin from '~/components/car/classifieds/form/fieldsets/handlers/BaseFieldsetMixin.vue'
import {
  defineComponent,
  computed,
  toRefs,
  useRouter
} from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_FORM_NS,
  FormState
} from '~/store/modules/shared/classifieds/form/state'
import { ciExternalLink } from '~/icons/source/regular/external-link'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useDeps } from '~/compositions/dependency-container'
import { LegacyUrlService } from '~/services/legacy/url/LegacyUrlService'
import { useApp } from '~/compositions/app'

export default defineComponent({
  components: { Fieldset },
  mixins: [BaseFieldsetMixin],
  setup(props) {
    const { fields } = toRefs(props)

    const { isPlot } = useApp()
    const { state: formState } = useNamespacedStore<FormState>(
      CLASSIFIED_FORM_NS
    )
    const { getters: userGetters } = useNamespacedStore<UserState>(USER_NS)
    const router = useRouter()
    const [legacyUrlService] = useDeps(LegacyUrlService)

    const isAnon = computed(() => userGetters('isSingleOrAnon'))

    const tradesSettingsField = fields.value.find(
      f => f.name === 'trades_settings'
    )

    const classifiedId = computed(() => formState.classifiedId)

    const tradesPageUrl = computed(() => {
      const tradesSettingsFields = fields.value.find(
        f => f.name === 'trades_settings'
      )
      if (tradesSettingsFields?.specs.show_trades_link && classifiedId.value) {
        return router.resolve({
          name: '__trades_swipe',
          params: { cid: classifiedId.value.toString() }
        }).href
      }
      return null
    })

    const loginUrl = computed(() => {
      if (process.client) {
        return `${legacyUrlService.getUserLoginUrl()}?gotonext=${
          window.location.href
        }`
      }
      return legacyUrlService.getUserLoginUrl()
    })

    const formIsDispatched = computed(() => formState.isDispatched)

    const showAnonTexts = computed(() => {
      return (
        isAnon.value &&
        !formIsDispatched.value &&
        tradesSettingsField?.specs.show_anon_message
      )
    })

    return {
      ciExternalLink,
      isPlot,
      tradesPageUrl,
      isAnon,
      loginUrl,
      showAnonTexts
    }
  }
})
